window.Subscription = {
    informationRequest: function(plugin, withConfirmation){
        SubscriptionRequest.create('information', plugin, withConfirmation);
    },
    upgradeRequest: function(withConfirmation){
        SubscriptionRequest.create('plan', '', false, withConfirmation, true);
    },
    upsellRequest: function(context, plugin, withConfirmation, showPopupOnSuccess){
        SubscriptionRequest.create(context, plugin, false, withConfirmation, showPopupOnSuccess);
    },
    renewRequest: function(context, plugin, id){
        SubscriptionRequest.create(context, plugin, id, false, true);
    },
    contactRequest: function(context){
        SubscriptionRequest.contactSales(context);
    }
};